import {useMutation} from "@tanstack/vue-query";

export function getPDPOffersMutation() {
    return useMutation(({product_id = 0, variant_id = null}) => {
        return useNuxtApp().$axios.get(`?route=rest/product_admin/get_offers_list`,
            {
                params: {
                    product_id,
                    variant_id
                }
            }
        ).then((response) => response?.data || {});
    });
}